import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'ramda';
import { sendMM } from '../../../stores/marketing-materials/actions';
import {
  DropDownMenu,
  FlatButton,
  FontIcon,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui';
import { propOr, without } from 'ramda';

const ReviewPartners = props => {
  const {
    updateMMPartnerProp,
    sendMarketingMaterials,
    actionItems,
    clearReducer,
    isSupplier,
    showActions,
  } = props;
  const MMPartnerReducer = isEmpty(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  // workaround for dropdown menu not closing
  const hideDropdownMenu = Boolean(
    MMPartnerReducer.showAddIndividuallyDialog ||
    MMPartnerReducer.showSelectFromPartnersDialog ||
    MMPartnerReducer.showUploadFileDialog ||
    MMPartnerReducer.showEmailImportDialog
    );

  return (
    <div style={{ marginTop: isSupplier ? '15px' : '' }}>
      <div>
        {
          hideDropdownMenu ? <span/> :
            <DropDownMenu
              value={3}
              labelStyle={{ color: '#00bcd4' }}
              underlineStyle={{ border: 'none' }}
              menuStyle={{ overflowY: 'hidden', overflowX: 'hidden' }}
              style={{ overflowY: 'hidden', overflowX: 'hidden', overflow: 'hidden' }}
            >
              {
                actionItems.map((actionItem, index) => (
                  <div key={index}>
                    <MenuItem
                      onClick={actionItem.func}
                      value={index}
                      key={index}
                      primaryText={actionItem.text}
                      leftIcon={<FontIcon className={actionItem.icon} style={{ color: '#757575' }} />}
                    />
                  </div>
                ))
              }
              <MenuItem value={3} label="ADD PARTNERS" />
            </DropDownMenu>
        }
      </div>
      <div style={{ maxHeight: '500px', overflowY: 'scroll' }}>
        <Table>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn>Company Name</TableHeaderColumn>
              <TableHeaderColumn>Email</TableHeaderColumn>
              <TableHeaderColumn/>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {
              propOr([], 'partnersToSendTo', MMPartnerReducer).map((obj, i) => (
                <TableRow key={i} style={{ height: '32px' }}>
                  <TableRowColumn style={{ height: '32px', fontSize: '14px' }}>
                    {obj.companyName}
                  </TableRowColumn>
                  <TableRowColumn style={{ height: '32px', fontSize: '14px' }}>
                    {obj.email}
                  </TableRowColumn>
                  <TableRowColumn style={{ height: '32px', fontSize: '14px', textAlign: 'right' }}>
                    <IconButton
                      iconClassName="tc-icon-delete2"
                      iconStyle={{ color: 'rgb(255, 64, 129)' }}
                      onTouchTap={() => updateMMPartnerProp({
                        partnersToSendTo: without([obj], MMPartnerReducer.partnersToSendTo),
                      })}
                    />
                  </TableRowColumn>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </div>
      { showActions ?
      <div style={{ marginTop: '20px' }}>
          <FlatButton
            label="exit"
            primary
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => clearReducer()}
            style={{ float: 'left' }}
          />
          <FlatButton
            label="send marketing materials"
            labelStyle={{ fontWeight: '600' }}
            secondary
            onTouchTap={() => {
              sendMarketingMaterials(MMPartnerReducer.partnersToSendTo);
              clearReducer();
            }}
            style={{ float: 'right' }}
          />
        </div> : <span /> }
    </div>
  );
};

ReviewPartners.propTypes = {
  updateMMPartnerProp: PropTypes.func,
  MMPartnerReducer: PropTypes.object,
  MMPartnerReducer2: PropTypes.object,
  sendMarketingMaterials: PropTypes.func,
  actionItems: PropTypes.array,
  clearReducer: PropTypes.func,
  isSupplier: PropTypes.bool,
  showActions: PropTypes.bool,
};

ReviewPartners.defaultProps = {
  showActions: true,
  MMPartnerReducer2: {},
};

const mapDispatchToProps = dispatch => ({
  sendMarketingMaterials: (...args) => dispatch(sendMM(...args)),
});

const mapStateToProps = ({ marketingMaterials }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewPartners);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/review-partners.jsx